import { useAuthStore } from '../stores/authStore'
import { useSyncStore } from '../stores/syncStore'

export default function SovereigntyBar() {
  const { user, logout } = useAuthStore()
  const { isConnected, lastSync, queueLength, isSyncing } = useSyncStore()

  const formatLastSync = () => {
    if (!lastSync) return 'Never'
    const diff = Date.now() - lastSync.getTime()
    if (diff < 60000) return 'Just now'
    if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`
    return lastSync.toLocaleTimeString()
  }

  return (
    <header className="bg-bg-surface border-b border-border px-6 py-2 text-xs">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-6">
          <span className="flex items-center gap-2">
            <span 
              className={`
                w-2 h-2 rounded-full
                ${isConnected ? 'bg-success' : 'bg-error'}
                ${isSyncing ? 'animate-pulse' : ''}
              `} 
            />
            <span className={`font-medium ${isConnected ? 'text-text-primary' : 'text-error'}`}>
              {isConnected ? 'Drive connected' : 'Drive offline'}
            </span>
          </span>
          
          <span className="text-text-secondary">
            Synced {formatLastSync().toLowerCase()}
          </span>
          
          {queueLength > 0 && (
            <span className={`text-action-primary font-medium ${isSyncing ? 'animate-pulse' : ''}`}>
              {queueLength} pending {isSyncing && '(syncing...)'}
            </span>
          )}
        </div>

        <div className="flex items-center gap-4">
          {user && (
            <>
              <span className="text-text-secondary">{user.email}</span>
              <button
                onClick={logout}
                className="text-text-secondary hover:text-text-primary transition-colors duration-150"
              >
                Sign out
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  )
}
